import { createServerFn } from "@tanstack/solid-start";
import { withSentrySpan } from "~/lib/sentry-span";
import { authFunctionMiddleware } from "~/server/middleware/auth";

export const getTelegramLinkStatus = createServerFn({ method: "GET" })
  .middleware([authFunctionMiddleware])
  .handler(async ({ context }) => {
    return withSentrySpan("telegramLink.getStatus", async () => {
      const { getLinkStatusForUser } = await import("./telegram-link.server");
      return getLinkStatusForUser(context.user.id);
    });
  });

export const generateTelegramLinkToken = createServerFn({ method: "POST" })
  .middleware([authFunctionMiddleware])
  .handler(async ({ context }) => {
    return withSentrySpan("telegramLink.generateLink", async () => {
      const { generateLinkToken } = await import("./telegram-link.server");
      const token = await generateLinkToken(context.user.id);
      return { token };
    });
  });

export const unlinkTelegramAccount = createServerFn({ method: "POST" })
  .middleware([authFunctionMiddleware])
  .handler(async ({ context }) => {
    return withSentrySpan("telegramLink.unlink", async () => {
      const { unlinkTelegramForUser } = await import("./telegram-link.server");
      await unlinkTelegramForUser(context.user.id);
      return { success: true as const };
    });
  });
